module.exports = __webpack_public_path__ + "static/construction-bb621236d473100a726ab19612cb5800.jpg";